import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import Loader from "../../../components/shared/Loader";
import userPlaceholder from "../../../assets/images/placeholder.jpg";
import { updateMeta } from "../../../store/actions/metaAction";
import { useHistory } from "react-router-dom";

const PostsShow = ({ match }) => {
	const {
		params: { postId },
	} = match;

	const auth = useSelector(state => state.auth.user);
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [titleEn, setTitleEn] = useState("");
	const [descriptionEn, setDescriptionEn] = useState("");
	const [loading, setLoading] = useState(true);
	const [picture, setPicture] = useState(userPlaceholder);
	const dispatch = useDispatch();
	const history = useHistory();

	useEffect(() => {
		onStart();
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "تعديل تفاصيل البوستات",
				breadcrumb: "البوستات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/posts/${postId}`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setTitle(response.data.data.data.title.ar);
				setTitleEn(response.data.data.data.title.en);
				setDescription(response.data.data.data.desc.ar);
				setDescriptionEn(response.data.data.data.desc.en);
				setPicture(response.data.data.data.image);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = () => {
		setLoading(true);
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
		const data = new FormData();
		data.append("file", fileInput.files[0]);
		axios
			.post(`${process.env.REACT_APP_MAIN_URL}/api/admincp/upload`, data, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
					"Content-Type": "multipart/form-data",
				},
			})
			.then(response => {
				setPicture(process.env.REACT_APP_MAIN_URL + response.data.data.name);
				setLoading(false);
				history.push("/industryPage/posts/index");
				toast.success("تم رفع الصورة بنجاح!");
			})
			.catch(error => {
				toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
				setLoading(false);
			});
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (!title || !titleEn || !description || !descriptionEn) {
			return toast.error("جميع البيانات مطلوبة");
		}
		setLoading(true);
		const data = {
			title: {
				ar: title,
				en: titleEn,
			},

			desc: {
				ar: description,
				en: descriptionEn,
			},
			image: picture,
		};
		axios
			.put(
				`${process.env.REACT_APP_API_URL}/posts/${postId}`,
				{
					admin_id: auth.id,
					category_id: 28,
					data: data,
				},
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				history.push("/industryPage/posts/index");
				toast.success("تم تحديث الصوره بنجاح!");
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة مره اخرى!");
				setLoading(false);
			});
	};

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-8">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										value={title}
										onChange={e => setTitle(e.target.value)}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description">الوصف</label>
									<textarea
										id="description"
										cols="30"
										rows="2"
										onChange={e => setDescription(e.target.value)}
										value={description}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="title"> العنوان بالانجليزيه </label>
									<input
										type="text"
										id="title"
										onChange={e => setTitleEn(e.target.value)}
										value={titleEn}
									/>
								</div>

								<div className="form-item">
									<label htmlFor="description"> الوصف بالانجليزيه</label>
									<textarea
										id="description"
										cols="30"
										rows="2"
										onChange={e => setDescriptionEn(e.target.value)}
										value={descriptionEn}
									/>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-4">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default PostsShow;
